import { Layout } from "layouts";

import { Hero, Investors } from "@/components/who-we-are/index";

const WhoWeAre: React.FC = () => {
    return (
        <Layout page="who-we-are">
            <Hero />
            <Investors />
        </Layout>
    );
};

export default WhoWeAre;
